<template>
  <b-modal
    :modal-class="[
      'document-modal',
      'single-document-modal',
      sidebarItems.length > 1 ? 'multiple-documents' : ''
    ]"
    v-model="editorShown"
    :size="modalSize"
    no-close-on-backdrop
    no-close-on-esc
    hide-header
    hide-footer
    centered
    @hide="closeModal"
  >
    <complete-documents-bulk-modal
      :open="showCompleteBulkModal"
      @close="showCompleteBulkModal = false"
      :documents="documentsFromSidebarItemsIds"
      @completeLock="completeBulkDocumentsReview"
    />
    <div class="d-flex h-100 position-relative">
      <div class="overlay" :class="showOverlay ? 'show' : ''">
        <div class="d-flex flex-column align-items-center ">
          <img width="200" :src="showOverlay ? checkGif : ''" />
          <span style="color: #2fd0f4; font-size: 20px; margin-top: -16px;"
          >Document completed
          </span>
          <span style="color: #27d58e; font-size: 24px; font-weight: bold;"
          >Well done!!</span
          >
        </div>
      </div>
      <div
        v-if="sidebarItems.length > 1"
        class="sidebar-forms-container bg-extra-light-gray"
      >
        <div class="d-flex font-weight-bold px-3 my-3" style="font-size:16px;">
          {{ sidebarTitle }}
          <div class="ml-auto">
            <b-dropdown variant="info" right toggle-class="" size="sm">
              <template #button-content>
                <i class="fa fa-cog mr-2" aria-hidden="true"></i>
              </template>
              <b-dropdown-item @click="showSignModal = true">
                <i
                  class="fa fa-thin fa-signature mr-2"
                  style="width: 16px;"
                ></i>
                Sign documents
              </b-dropdown-item>
              <b-dropdown-item-button
                @click="triggerBulkModal"
                :disabled="thereIsNoPendingDocuments"
              >
                <i class="far fa-copy mr-2" style="width: 16px;"></i>Complete
                documents
              </b-dropdown-item-button>
            </b-dropdown>
          </div>
        </div>
        <div class="sidebar-forms">
          <div
            v-for="(sidebarItem, sidebarItemIndex) in sidebarItems"
            :key="sidebarItemIndex"
          >
            <div
              @click="
                formIsEnabledInLocation(sidebarItem) &&
                  prevSetCurrentFormItem(sidebarItemIndex)
              "
              class="sidebar-menu-form-item d-flex align-items-center"
              :class="[
                sidebarItemIndex == selectedSidebarItemIndex ? 'active' : '',
                !formIsEnabledInLocation(sidebarItem) ? 'inactive' : '',
                sidebarItem.subtitle ? 'mb-2' : ''
              ]"
              :style="{ minHeight: sidebarItem.subtitle ? '50px' : '44px' }"
            >
              <div class="w-100 justify-content-end pt-2 pb-2">
                <b-container class="ml-0 p-0">
                  <b-row>
                    <b-col cols="3" v-if="formIsEnabledInLocation(sidebarItem)">
                      <b-badge
                        :variant="getStatusClass(sidebarItem)"
                        class="text-white"
                      >{{ getStatus(sidebarItem).toUpperCase() }}
                      </b-badge>
                    </b-col>
                    <b-col cols="5" style="margin-top: auto;margin-left: 16px;">
                      <div
                        v-if="sidebarItem.documentRefNumber"
                        style="font-size: 14px;"
                      >
                        Ref#: {{ sidebarItem.documentRefNumber }}
                      </div>
                    </b-col>
                    <b-col cols="1" v-if="formIsEnabledInLocation(sidebarItem)">
                      <i
                        class="fa fa-times"
                        @click="hideForm(sidebarItemIndex)"
                      ></i>
                    </b-col>
                  </b-row>
                </b-container>
                <div style="font-size: 14px;">
                  {{ sidebarItem.name }}
                </div>
                <div style="font-size: 14px;">
                  {{ formatDate(sidebarItem.date) }}
                </div>
                <div
                  style="font-size: 14px;"
                  :class="
                    `text-${getParticipantStatusClass(sidebarItem.statusName)}`
                  "
                >
                  {{ sidebarItem.statusName }}
                </div>
                <div style="font-size: 14px;">
                  {{
                    sidebarItem.mrn && sidebarItem.patient
                      ? sidebarItem.mrn + " " + sidebarItem.patient
                      : ""
                  }}
                </div>
                <div
                  v-if="
                    sidebarItem.totalSignature &&
                      sidebarItem.totalSignature -
                        sidebarItem.completedSignature !=
                        0
                  "
                  class="d-inline"
                  style="font-size: 0.775em; color: #d9534f"
                >
                  {{
                    sidebarItem.totalSignature - sidebarItem.completedSignature
                  }}
                  <p class="d-inline">
                    {{
                      sidebarItem.totalSignature -
                      sidebarItem.completedSignature !=
                      1
                        ? "pending signatures"
                        : "pending signature"
                    }}
                  </p>
                </div>
                <div
                  v-if="
                    sidebarItem.completedSignature > 0 &&
                      sidebarItem.totalSignature ==
                        sidebarItem.completedSignature
                  "
                  style="font-size: 0.775em; color: #5cb85c"
                >
                  All signed
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="main-container bg-white border-radius-top border-radius-bottom"
        :style="{
          width: sidebarItems.length > 1 ? 'calc(100% - 600px)' : '100%',
          zIndex: 2
        }"
      >
        <div
          class="d-flex flex-row justify-content-between align-items-center bg-purple text-white border-radius-top"
          style="padding: 10px 20px;"
        >
          <div>
            <h5 class="modal-title font-weight-bold mb-1">{{ modalTitle }}</h5>
            <div class="modal-subtitle">{{ modalSubtitle }}</div>
          </div>
          <button
            type="button"
            aria-label="Close"
            class="close text-white"
            style="opacity:1 !important"
            @click="closeModal"
          >
            ×
          </button>
        </div>
        <div class="text-center h-100" v-if="currentForm">
          <div
            class=" headers-options bg-extra-light-gray border-bottom"
            style="padding: 10px 20px; gap: 10px;"
          >
            <div>
              <b-input-group>
                <effective-date-time-picker
                  :disabled="
                    (document && document.status == 'Completed') ||
                      effectiveDateTimePickerDisabled
                  "
                  v-model="effectiveDateTime"
                  :errors="effectiveDateTimeErrors"
                />
              </b-input-group>
            </div>

            <option-switch v-model="documentStatus" :options="statuses" />

            <div class="d-flex align-items-center">
              <next-review-date-picker
                v-if="formIsTreatmentPlan"
                :disabled="
                  (document && document.status == 'Completed') ||
                    effectiveDateTimePickerDisabled
                "
                v-model="nextReviewDate"
                :errors="nextReviewDateErrors"
                @input="updateNextReviewDate"
              />
              <div
                class="text-right ml-auto ml-xl-0"
                style="padding-left: 10px;"
              >
                <b-dropdown variant="info" right toggle-class="" size="sm">
                  <template #button-content>
                    <i class="fa fa-cog mr-2" aria-hidden="true"></i>
                    <div id="option-text">Options</div>
                  </template>
                  <b-dropdown-item-button
                    v-if="copyPasteActive"
                    @click="copyFormValuesToClipboard"
                  >
                    <i class="far fa-copy mr-2" style="width: 16px;"></i>Copy
                    content
                  </b-dropdown-item-button>
                  <b-dropdown-item-button
                    v-if="copyPasteActive"
                    @click="pasteContentFromClipboard"
                    :disabled="document && document.status == 'Completed'"
                  ><i class="far fa-clipboard mr-2" style="width: 16px;"></i
                  >Paste content
                  </b-dropdown-item-button>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item-button
                    :disabled="
                      !lastDocument ||
                        (document && document.status == 'Completed')
                    "
                    @click="loadLastResult"
                  ><i class="fas fa-history mr-2" style="width: 16px;"></i
                  >Load from last result
                  </b-dropdown-item-button>
                </b-dropdown>
              </div>
            </div>
          </div>
          <div class="document-container">
            <div class="position-relative flex-grow-1 p-3">
              <div
                class="disable-form bg-med-light-gray"
                v-if="document && document.status == 'Completed'"
              ></div>
              <b-row>
                <b-col>
                  <div class="text-center">
                    <div class="builder w-100">
                      <div class="text-left" v-if="preFormComponent">
                        <component
                          :is="preFormComponent"
                          :documentId="localDocumentId"
                          :effectiveDateTime="effectiveDateTime"
                          :documentStatus="documentStatus"
                          :eocId="eocId"
                          ref="preFormComponent"
                        ></component>
                      </div>
                      <fb-form-viewer
                        :json="currentForm.version.content.layout"
                        showType="form-submitter"
                        ref="formViewer"
                        @updateTotalPages="n => (totalPages = n)"
                      ></fb-form-viewer>
                      <div v-if="updatedDocumentsRenderIndex >= 0">
                        <fb-form-viewer
                          style="display: none"
                          :json="
                            updatedDocuments[updatedDocumentsRenderIndex]
                              .formLayout
                          "
                          :results="
                            updatedDocuments[updatedDocumentsRenderIndex]
                              .document.results
                          "
                          showType="form-submitter"
                          @mounted="
                            setMainLayoutMounted(
                              updatedDocuments[updatedDocumentsRenderIndex],
                              $event
                            )
                          "
                        ></fb-form-viewer>
                        <component
                          style="display: none"
                          :is="
                            getDoctorOrderOrNull(
                              updatedDocuments[updatedDocumentsRenderIndex]
                                .document.form
                            )
                          "
                          :documentId="
                            updatedDocuments[updatedDocumentsRenderIndex]
                              .document.id
                          "
                          :effectiveDateTime="
                            updatedDocuments[updatedDocumentsRenderIndex]
                              .document.effectiveDate
                          "
                          :documentStatus="
                            updatedDocuments[updatedDocumentsRenderIndex]
                              .document.status
                          "
                          :eocId="
                            updatedDocuments[updatedDocumentsRenderIndex]
                              .document.episodeOfCareId
                          "
                          @mounted="
                            setDoctorOrderlayoutMounted(
                              updatedDocuments[updatedDocumentsRenderIndex],
                              $event
                            )
                          "
                        ></component>
                        <component
                          style="display: none"
                          :is="
                            getReleaseOfInformationOrNull(
                              updatedDocuments[updatedDocumentsRenderIndex]
                                .document.form
                            )
                          "
                          :documentId="
                            updatedDocuments[updatedDocumentsRenderIndex]
                              .document.id
                          "
                          :effectiveDateTime="
                            updatedDocuments[updatedDocumentsRenderIndex]
                              .document.effectiveDate
                          "
                          :documentStatus="
                            updatedDocuments[updatedDocumentsRenderIndex]
                              .document.status
                          "
                          :eocId="
                            updatedDocuments[updatedDocumentsRenderIndex]
                              .document.episodeOfCareId
                          "
                          @mounted="
                            setReleaseOfInformationlayoutMounted(
                              updatedDocuments[updatedDocumentsRenderIndex],
                              $event
                            )
                          "
                        ></component>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
          <div
            class="d-flex justify-content-between align-items-center bg-extra-light-gray position-relative border-top border-radius-bottom"
            style="padding: 10px 20px; gap: 10px;"
          >
            <div
              class="last-saved-container"
              :class="animateLastSaved ? 'animate-container' : ''"
              :style="document && document.score ? 'padding-top: 9px;' : ''"
            >
              <div
                class="d-flex align-items-center mr-2 color-custom-dark-grey"
                v-if="document && document.lastUpdated"
              >
                <i class="fa fa-save mr-2 text-primary"></i>
                <div>
                  <span style="font-size: 12px">
                    Last saved: {{ formatDate(document.lastUpdated) }}
                    <span class="text-primary">
                      ({{ formatTimeAgo(document.lastUpdated) }})
                    </span>
                  </span>
                  <div
                    v-if="document && document.score"
                    class="d-flex align-items-center text-primary"
                    style="margin-top: -5px;"
                  >
                    <span class="mb-0 mr-2">
                      Score:
                    </span>
                    <span>{{ document.score }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div style="width: 57px;"></div>
            <div class="text-danger text-left">
              {{ validationErrorMessage }}
            </div>
            <div class="mt-1 text-right">
              <b-button @click="closeModal" variant="secondary" class="mr-2">
                Close
              </b-button>
              <b-button
                v-if="
                  documentStatus == 'Completed' &&
                    (!document || (document && document.status != 'Completed'))
                "
                variant="success"
                @click="lockDocument"
              >
                Complete & Lock
              </b-button>
              <b-button
                v-else-if="
                  documentStatus == 'Completed' &&
                    document &&
                    document.status == 'Completed'
                "
                variant="danger"
                :disabled="
                  !hasCurrentUserDocumentPermission(formId, 'hasCompleteAccess')
                "
                @click="showUnlockDocument = true"
              >
                <i class="fa fa-unlock mr-2" aria-hidden="true"></i>Unlock
              </b-button>
              <span v-else>
                <b-button variant="primary" @click="submitForm()">
                  Save
                </b-button>
                <b-button
                  v-if="sidebarItems && sidebarItems.length > 1"
                  variant="primary"
                  @click="submitForm({}, true)"
                  class=" ml-2"
                >
                  Save & Next
                </b-button>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="sidebar">
        <div class="sidebar-inner h-100">
          <div
            style="height: 139px;"
            class="d-flex flex-column justify-content-around border-bottom mb-2"
          >
            <div
              class="d-flex align-items-center px-3 sidebar-options"
              style="margin-top: 10px; margin-bottom: 10px;"
            >
              <div
                @click="selectedSidebarTab = 'notes'"
                class="sidebar-tab-title px-1 hover-pointer"
              >
                <div class="d-flex flex-column justify-content-center">
                  <span
                    class="badge-v2 py-2 sidebar-badge badge-fixed-size"
                    :class="
                      selectedSidebarTab == 'notes' ? 'selected-badge' : ''
                    "
                  >Notes</span
                  >
                </div>
              </div>
              <div
                @click="openOmtTab"
                class="sidebar-tab-title px-1 hover-pointer"
              >
                <div class="d-flex flex-column justify-content-center">
                  <span
                    class="badge-v2 py-2 sidebar-badge badge-fixed-size"
                    :class="selectedSidebarTab == 'omt' ? 'selected-badge' : ''"
                  >OMT</span
                  >
                </div>
              </div>
              <div
                @click="selectedSidebarTab = 'cptCodes'"
                class="sidebar-tab-title px-1 hover-pointer"
                v-if="scheduleEventIdValue"
              >
                <div class="d-flex flex-column justify-content-center">
                  <span
                    class="badge-v2 py-2 sidebar-badge badge-fixed-size"
                    :class="
                      selectedSidebarTab == 'cptCodes' ? 'selected-badge' : ''
                    "
                  >CPT Codes</span
                  >
                </div>
              </div>
            </div>
            <div
              class="d-flex px-3 sidebar-options"
              style="margin-bottom: 10px;"
            >
              <div
                @click="selectedSidebarTab = 'icdCodes'"
                class="sidebar-tab-title px-1 hover-pointer"
              >
                <div class="d-flex flex-column justify-content-center">
                  <span
                    class="badge-v2 py-2 sidebar-badge badge-fixed-size"
                    :class="
                      selectedSidebarTab == 'icdCodes' ? 'selected-badge' : ''
                    "
                  >ICD Codes</span
                  >
                </div>
              </div>
              <div
                @click="selectedSidebarTab = 'instructions'"
                class="sidebar-tab-title px-1 hover-pointer"
                v-if="
                  currentForm &&
                    currentForm.form &&
                    currentForm.form.documentInstructions
                "
              >
                <div class="d-flex flex-column justify-content-center">
                  <span
                    class="badge-v2 py-2 sidebar-badge badge-fixed-size"
                    :class="
                      selectedSidebarTab == 'instructions'
                        ? 'selected-badge'
                        : ''
                    "
                  >Instructions</span
                  >
                </div>
              </div>
              <div
                @click="selectedSidebarTab = 'allergies'"
                class="sidebar-tab-title px-1 hover-pointer"
              >
                <div class="d-flex flex-column justify-content-center">
                  <span
                    class="badge-v2 py-2 sidebar-badge badge-fixed-size"
                    :class="
                      selectedSidebarTab == 'allergies' ? 'selected-badge' : ''
                    "
                  >Allergies</span
                  >
                </div>
              </div>
            </div>
            <div
              class="d-flex px-3 sidebar-options"
              style="margin-bottom: 10px;"
              v-if="hasAppointmentRelated"
            >
              <div
                @click="selectedSidebarTab = 'appointment'"
                class="sidebar-tab-title px-1 hover-pointer"
              >
                <div class="d-flex flex-column justify-content-center">
                  <span
                    class="badge-v2 py-2 sidebar-badge badge-fixed-size"
                    :class="
                      selectedSidebarTab == 'appointment'
                        ? 'selected-badge'
                        : ''
                    "
                  >Appointment</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            class="h-100"
            style="overflow-y:auto; overflow-x:hidden; padding: 0px 15px;"
          >
            <document-notes-tab-content
              v-show="selectedSidebarTab == 'notes'"
              ref="documentNotes"
              :documentId="localDocumentId"
              @onChange="refetchDocuments = true"
            />
            <div
              v-if="selectedSidebarTab == 'instructions'"
              class="flex-grow-1 p-2 mx-2 document-instructions"
              v-html-sanitize="currentForm.form.documentInstructions"
            />
            <document-omt-tab-content
              v-if="selectedSidebarTab == 'omt'"
              :results="omtResults[eocId]"
            />
            <document-icd-codes-tab-content
              v-if="selectedSidebarTab == 'icdCodes'"
              :eocId="eocId"
              :patientId="clientId"
              @onChange="onIcdCodesTabChange"
              :scheduleEventId="scheduleEventIdValue"
              :readonly="document && document.status == 'Completed'"
            />
            <document-allergies-tab-content
              v-if="selectedSidebarTab == 'allergies'"
              :eocId="eocId"
              :patientId="clientId"
              :readonly="document && document.status == 'Completed'"
              @onAllergyModify="onAllergyModify"
              @onAllergyDelete="onAllergyDelete"
            />
            <document-cpt-codes-tab-content
              v-if="selectedSidebarTab == 'cptCodes'"
              :eocId="eocId"
              :patientId="clientId"
              :scheduleEventId="scheduleEventIdValue"
              @onChange="onIcdCodesTabChange"
            />
            <document-appointment-tab-content
              v-if="selectedSidebarTab == 'appointment'"
              :scheduleEventId="scheduleEventId"
            />
          </div>
        </div>
      </div>
    </div>
    <dialog-unlock-document
      v-if="showUnlockDocument"
      v-model="showUnlockDocument"
      @confirm="unlockDocument"
      @cancel="showUnlockDocument = false"
    />
    <sign-documents-modal
      :docIds="pendingOrDraftDocuments"
      v-if="showSignModal"
      v-model="showSignModal"
      @cancel="showSignModal = false"
      @signAll="signAll"
    />
    <review-documents-modal
      :docs="
        reviewDocumentMode
          ? documentsForCompleteReview
          : updatedDocuments.map(x => {
              return {
                id: x.document.id,
                bakedLayout: x.document.bakedLayout
              };
            })
      "
      v-if="showReviewDocumentsModal"
      v-model="showReviewDocumentsModal"
      @signAll="confirmSigning"
      @completeAll="bulkCompleteForm"
      @close="closeSigning"
      :mode="reviewDocumentMode"
    />
  </b-modal>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import moment from "moment";
import serverCatalog from "../../server/catalog";
import serverEoc from "../../server/eoc";
import scheduledMedicationServer from "../../server/scheduledMedication";
import documentServer from "../../server/document";
import scheduleEventServer from "../../server/scheduleEvent";
import {
  formatDateOnlyMysql,
  formatDateTimeSql,
  formatDateTimeMysql
} from "../../helpers/date";
import { hasClass } from "../../helpers/layout";
import EffectiveDateTimePicker from "../controls/EffectiveDateTimePicker";
import NextReviewDatePicker from "../controls/NextReviewDatePicker.vue";
import OptionSwitch from "../controls/OptionSwitch.vue";
import { validateRequired, validateDateTime } from "../../helpers/validation";
import { getFormBuilderComponents } from "../../../../Breeze.FormBuilder.Frontend/helpers/formBuilder";
import DocumentNotesTabContent from "../episode_of_care/document/DocumentNotesTabContent.vue";
import DocumentOmtTabContent from "../episode_of_care/document/DocumentOmtTabContent.vue";
import DocumentIcdCodesTabContent from "../episode_of_care/document/DocumentIcdCodesTabContent.vue";
import DocumentAllergiesTabContent from "../episode_of_care/document/DocumentAllergiesTabContent.vue";
import DocumentCptCodesTabContent from "../episode_of_care/document/DocumentCptCodesTabContent.vue";
import DialogUnlockDocument from "../controls/DialogUnlockDocument";
import DocumentDoctorOrder from "../episode_of_care/document/DocumentDoctorOrder";
import DocumentReleaseOfInformation from "../episode_of_care/document/DocumentReleaseOfInformation.vue";
import SignDocumentsModal from "./SignDocumentsModal";
import ReviewDocumentsModal from "./ReviewDocumentsModal";
import CompleteDocumentsBulkModal from "./CompleteDocumentsBulkModal.vue";
import DocumentAppointmentTabContent from "../episode_of_care/document/DocumentAppointmentTabContent.vue";
import doctorOrderServer from "../../server/doctorOrder";

export default {
  name: "DocumentsAddEditModal",
  components: {
    EffectiveDateTimePicker,
    NextReviewDatePicker,
    OptionSwitch,
    DocumentNotesTabContent,
    DocumentOmtTabContent,
    DocumentIcdCodesTabContent,
    DocumentAllergiesTabContent,
    DocumentCptCodesTabContent,
    DialogUnlockDocument,
    SignDocumentsModal,
    ReviewDocumentsModal,
    CompleteDocumentsBulkModal,
    DocumentAppointmentTabContent
  },
  props: [
    "sidebarItems",
    "selectedSidebarItemIndex",
    "sidebarTitle",
    "modalTitle",
    "modalSubtitle",
    "reloadSelectedDocument",
    "isFormGroup",
    "groupSessionId",
    "scheduleEventId",
    "scheduleEventParticipantId",
    "disableEffectiveDatePicker",
    "documents",
    "attachForm",
    "hasAppointmentRelated"
  ],
  data() {
    return {
      submit: null,
      formId: "",
      document: null,
      validationErrorMessage: "",
      effectiveDateTime: null,
      effectiveDateTimeErrors: [],
      nextReviewDate: null,
      nextReviewDateErrors: [],
      refetchDocuments: false,
      initialEffectiveDate: null,
      initialEffectiveTime: null,
      clientId: null,
      client: {},
      documentStatus: "Pending",
      eocId: null,
      eoc: null,
      documentInstructions: "",
      animateLastSaved: false,
      selectedSidebarTab: "notes",
      showOverlay: false,
      showUnlockDocument: false,
      checkGif: require("../../assets/simple-check.gif"),
      currentForm: null,
      modalSize: "lg",
      documentGroupId: null,
      localDocumentId: null,
      parentDocumentId: null,
      otherResults: null,
      defaultValues: null,
      initialEffectiveDateTime: null,
      disableDocumentEffectiveDatePicker: false,
      omtResults: {},
      diagnosisCodes: [],
      lastDocument: null,
      showSignModal: false,
      updatedDocuments: [],
      updatedDocumentsRenderIndex: -1,
      documentsForCompleteReview: [],
      showReviewDocumentsModal: false,
      showCompleteBulkModal: false,
      reviewDocumentMode: "",
      documentsFromSidebarItemsIds: [],
      totalPages: 1,
      score: 0,
      localUnsavedChanges: false
    };
  },
  async mounted() {
    this.initializeFormData();
    document.addEventListener("keydown", this.checkIfHasServiceBeforeClose);
    window.addEventListener("message", this.nablaCopilotEventHandler);
  },
  destroyed() {
    document.removeEventListener(
      "keydown",
      this.checkIfHasServiceBeforeClose,
      false
    );
    window.removeEventListener("message", this.nablaCopilotEventHandler, false);
  },
  methods: {
    ...mapMutations("formGroupSubmitter", ["initializeFormGroupSubmit"]),
    ...mapMutations("formSubmitter", [
      "setInitialValues",
      "setFormSubmitterFormHasUnsavedChanges",
      "setDocumentData"
    ]),
    ...mapActions("formGroupSubmitter", ["addFormGroupSubmit"]),
    ...mapActions("formSubmitter", [
      "addFormSubmitterForm",
      "editFormSubmitterForm",
      "bulkEditFormSubmitterForm",
      "validateFormSubmitterForm",
      "copyFormValuesToClipboard",
      "pasteFormValuesFromClipboard",
      "initializeFormSubmitterForm",
      "setFormSubmitterComponentValue"
    ]),
    ...mapActions("layout", ["showAlertSuccess"]),
    async checkIfHasServiceBeforeClose(e) {
      if (e.keyCode === 27) {
        await this.closeModal();
      }
    },
    nablaCopilotEventHandler(e) {
      if (e.data && e.data.nablaCopilot) {
        const note = e.data.nablaCopilot.note;
        const textInputAiKeys = Object.keys(this.values).filter(x =>
          x.startsWith("TextInputAiAutofill")
        );

        textInputAiKeys.forEach(x => {
          const section = this.computedProperties[x].sectionSelected;
          const sectionNote = note.find(x => x.type === section);

          if (sectionNote) {
            this.setFormSubmitterComponentValue({
              controlId: x,
              controlValue: sectionNote.value,
              userAction: true
            });
          }
        });
      }
    },
    async initializeFormData(
      selectedSidebarItemIndex = null,
      resetForm = true
    ) {
      if (selectedSidebarItemIndex == null) {
        selectedSidebarItemIndex = this.selectedSidebarItemIndex;
      }
      this.disableDocumentEffectiveDatePicker = false;
      this.selectedSidebarTab = "notes";
      this.localDocumentId = null;
      if (
        this.sidebarItems[selectedSidebarItemIndex].initialEffectiveDateTime
      ) {
        this.initialEffectiveDateTime = this.sidebarItems[
          selectedSidebarItemIndex
          ].initialEffectiveDateTime;
      }
      const currentAdjustedDateTime = this.getCurrentAdjustedDateTime();
      this.effectiveDateTime = this.initialEffectiveDateTime
        ? formatDateTimeMysql(this.initialEffectiveDateTime)
        : formatDateTimeMysql(currentAdjustedDateTime);
      this.initialEffectiveDate = formatDateOnlyMysql(currentAdjustedDateTime);
      this.initialEffectiveTime = moment(currentAdjustedDateTime).format(
        "HH:mm"
      );

      if (resetForm) {
        this.currentForm = null;
      }
      this.formId = this.sidebarItems[selectedSidebarItemIndex].formId;
      const form = await this.getFormBuilderFormById(this.formId);
      let version = await this.getFormBuilderFormVersionById(form.current.id);

      this.documentInstructions = form.documentInstructions;

      let documentId = this.sidebarItems[selectedSidebarItemIndex].documentId;

      await this.setInitialValues();
      let submit = null;
      if (documentId) {
        submit = await this.getFormSubmitById(documentId);
        version = await this.getFormBuilderFormVersionById(submit.versionId);
        this.localDocumentId = documentId;
        this.effectiveDateTime = formatDateTimeMysql(submit.effectiveDate);
        if (submit.scheduleEventId) {
          this.scheduleEventId = submit.scheduleEventId;
          const scheduleEvent = await scheduleEventServer.get(
            submit.scheduleEventId
          );
          if (scheduleEvent.type.name == "Group Session") {
            this.disableDocumentEffectiveDatePicker = true;
          } else if (scheduleEvent.type.name == "Appointment") {
            this.hasAppointmentRelated = true;
          }
        }
      }

      if (this.sidebarItems[selectedSidebarItemIndex].parentDocumentId) {
        this.parentDocumentId = this.sidebarItems[
          selectedSidebarItemIndex
          ].parentDocumentId;
      }

      if (this.sidebarItems[selectedSidebarItemIndex].otherResults) {
        this.otherResults = this.sidebarItems[
          selectedSidebarItemIndex
          ].otherResults;
      }

      if (this.sidebarItems[selectedSidebarItemIndex].defaultValues) {
        this.defaultValues = this.sidebarItems[
          selectedSidebarItemIndex
          ].defaultValues;
      }
      this.document = submit;
      this.documentStatus = submit
        ? submit.status
        : this.systemSetting.documentDefaultStatus;
      this.clientId = this.sidebarItems[selectedSidebarItemIndex].clientId;
      const client = await serverCatalog.getClient(this.clientId);
      this.eocId = this.sidebarItems[selectedSidebarItemIndex].eocId;
      const eoc = await serverEoc.get(this.eocId);
      this.eoc = eoc;
      if (this.sidebarItems[selectedSidebarItemIndex].documentGroupId) {
        this.documentGroupId = this.sidebarItems[
          selectedSidebarItemIndex
          ].documentGroupId;
      }
      if (this.document?.score) this.score = this.document.score;
      const eocCares = await scheduleEventServer.query({
        episodeOfCareIds: [this.eocId],
        types: ["LOC"]
      });
      const primaryProvider = eoc.caseLoads.find(
        cL => cL.caseRole.type == "PrimaryProvider"
      )
        ? eoc.caseLoads.find(cL => cL.caseRole.type == "PrimaryProvider").user
        : null;
      const medicationScheduledList = await scheduledMedicationServer.query(
        eoc.id,
        {}
      );

      const nextAppointment = await scheduleEventServer.getNextAppointment(
        this.eocId
      );

      const events = await this.getEocEvents(this.eocId, version);

      const clientFiltered = {
        id: client.id,
        mrn: client.mrn,
        firstName: client.firstName,
        middleName: client.middleName,
        lastName: client.lastName,
        dateOfBirth: client.dateOfBirth,
        email: client.email,
        phone: client.phone,
        ssn: client.ssn,
        ssnUnmasked: this.hasCurrentUserPermissionAccess("patients", "ssn")
          ? client.ssnUnmasked
          : "",
        gender: client.gender ? client.gender.name : "",
        race: client.race ? client.race.name : "",
        ethnicity: client.ethnicity ? client.ethnicity.name : "",
        language: client.language ? client.language.name : "",
        city: client.city,
        state: client.state ? client.state.name : "",
        maritalStatus: client.maritalStatus ? client.maritalStatus.name : "",
        occupation: client.occupation,
        zipcode: client.zipcode,
        addressLine1: client.addressLine1,
        addressLine2: client.addressLine2,
        facilityNpi: eoc.location.npiNo,
        currentUserNpi: this.currentUser.npi,
        episodeOfCare: {
          id: eoc.id,
          eocn: eoc.eocn,
          status: eoc.status,
          location: eoc.location
            ? {
              name: eoc.location.name,
              addressLine1: eoc.location.addressLine1,
              addressLine2: eoc.location.addressLine2,
              city: eoc.location.city,
              email: eoc.location.email,
              fax: eoc.location.fax,
              npiNo: eoc.location.npiNo,
              phoneNumber: eoc.location.phoneNumber,
              state: eoc.location.state,
              taxId: eoc.location.taxId,
              zipcode: eoc.location.zipcode
            }
            : {},
          startDate: eoc.startDate,
          endDate: eoc.endDate,
          additionalsReportResults: eoc.additionalsReportResults,
          referralSource: eoc.referralSource,
          primaryProvider: primaryProvider
            ? {
              id: primaryProvider.id,
              firstName: primaryProvider.firstName,
              lastName: primaryProvider.lastName,
              middleName: primaryProvider.middleName,
              credentials: primaryProvider.credentials
            }
            : null,
          eocCares: eocCares.map(eocC => ({
            day: formatDateOnlyMysql(eocC.startDateTime),
            levelOfCare:
              eocC.services.length > 0 ? eocC.services[0].service.name : ""
          })),
          medicationScheduledList: medicationScheduledList,
          nextAppointment: nextAppointment
        },
        insurances: client.insurances,
        allergies: client.allergies,
        contacts: client.contacts,
        guarantors: client.guarantors,
        documentCreatedBy: this.formatUser(this.currentUser),
        events
      };
      const scheduleEvent = this.scheduleEventId
        ? await scheduleEventServer.get(
            this.scheduleEventId
          )
        : null;
      const formEvent = scheduleEvent?.type?.id === 2
        ? {
            type: scheduleEvent.type,
            numberOfParticipants: scheduleEvent.episodesOfCare.length
          }
        : null;

      await this.initializeFormSubmitterForm({
        formId: this.formId,
        formName: form.name,
        version: version,
        client: clientFiltered,
        eoc: eoc,
        document: submit ? submit : null,
        otherResults: this.otherResults,
        defaultValues: this.defaultValues,
        showType: "form-submitter",
        selectedLocation: this.selectedLocation,
        scheduleEvent: formEvent
      });
      this.client = clientFiltered;
      this.effectiveDate = submit
        ? moment(submit.effectiveDate).format("YYYY-MM-DD")
        : this.initialEffectiveDate;
      this.effectiveTime = submit
        ? moment(submit.effectiveDate).format("HH:mm")
        : this.initialEffectiveTime;
      this.currentForm = { form, version };
      this.modalSize = this.currentForm.version.content.properties.modalSize
        ? this.currentForm.version.content.properties.modalSize.length > 0
          ? this.currentForm.version.content.properties.modalSize
          : "lg"
        : "lg";
      this.nextReviewDate =
        this.document && this.document.nextReviewDate !== null
          ? this.document.nextReviewDate
          : null;

      this.setDocumentData({
        status: this.documentStatus,
        effectiveDate: this.effectiveDateTime
      });

      let lastDocument = await documentServer.getLastDocument(
        this.formId,
        version.id,
        this.eocId,
        documentId
      );
      if (lastDocument) {
        lastDocument.results = Object.fromEntries(
          Object.entries(lastDocument.results).filter(
            ([key]) => !key.includes("Signature")
          )
        );
      }

      this.lastDocument = lastDocument;
    },
    async getEocEvents(eocId, version) {
      const hasFetchEventsActivated = version.content.properties.fetchEvents;
      if (hasFetchEventsActivated) {
        const events = await scheduleEventServer.getEventsByEoc(eocId);
        return events;
      }
      return [];
    },
    async validateFormSubmit() {
      let withoutErrors = await this.validateFormSubmitterForm();

      this.effectiveDateTimeErrors = [];
      if (!validateRequired(this.effectiveDateTime)) {
        this.effectiveDateTimeErrors.push("This field is required");
        withoutErrors = false;
      }

      if (this.effectiveDateTime && !validateDateTime(this.effectiveDateTime)) {
        this.effectiveDateTimeErrors.push(
          "This field must have a valid date format"
        );
        withoutErrors = false;
      }

      return withoutErrors;
    },
    async lockDocument() {
      let result = true;
      if (
        this.preFormComponent &&
        this.currentForm.form.category == "releaseOfInformation"
      ) {
        result = this.$refs[
          "preFormComponent"
          ].validateReleaseOfInformationSubmit();
      }
      result &&= await this.validateFormSubmit();
      if (result) {
        this.showOverlay = true;
        setTimeout(() => {
          this.showOverlay = false;
          if (
            this.sidebarItems &&
            this.selectedSidebarItemIndex + 1 < this.sidebarItems.length
          ) {
            this.submitForm({}, true);
          } else {
            this.submitForm();
          }
        }, 1800);
      } else {
        this.scrolltoErrors();
      }
    },
    scrolltoErrors() {
      let firstErrorElement = document.querySelector(".is-invalid");
      let topPos = 0;
      while (!hasClass(firstErrorElement, "document-container")) {
        topPos += firstErrorElement.offsetTop;
        firstErrorElement = firstErrorElement.offsetParent;
      }
      document.querySelector(".document-modal .document-container").scrollTop =
        topPos - 10;
      this.validationErrorMessage = "Please fix errors and try again.";
    },
    unlockDocument({ reason }) {
      this.documentStatus = "Pending";
      this.showUnlockDocument = false;
      this.submitForm({
        unlockReason: reason,
        callbackConfirm: async () => {
          this.$emit("setCurrentFormItem", {
            sidebarItemIndex: this.selectedSidebarItemIndex,
            prevDocumentStatus: "Pending",
            prevDocumentId: this.localDocumentId,
            prevDocumentGroupId: this.documentGroupId
          });
          this.document.status = "Pending";
        }
      });
    },
    async hideForm(sidebarItemIndex) {
      this.sidebarItems.splice(sidebarItemIndex, 1);
      this.localDocumentId = this.sidebarItems[sidebarItemIndex].documentId;
      this.document = this.localDocumentId
        ? await this.getFormSubmitById(this.localDocumentId)
        : this.sidebarItems[sidebarItemIndex];
      this.prevSetCurrentFormItem(sidebarItemIndex);
    },
    async submitForm(
      { callbackConfirm = null, unlockReason = null } = {},
      next = false
    ) {
      this.validationErrorMessage = "";
      let result = true;
      if (this.documentStatus != "Draft" && unlockReason == null) {
        if (
          this.preFormComponent &&
          this.currentForm.form.category == "releaseOfInformation"
        ) {
          result = this.$refs[
            "preFormComponent"
            ].validateReleaseOfInformationSubmit();
        }
        result &&= await this.validateFormSubmit();
      }
      if (result) {
        const bakedLayout = `<div>
          <div class="text-left">
            ${
          this.preFormComponent
            ? this.$refs.preFormComponent.getBakedLayout()
            : ""
        }
          </div>
          ${this.$refs.formViewer.getBakedLayout()}
        </div>`;

        let score = null;
        if (this.currentForm.version.content.properties.scoreFunctionBody) {
          score = this.superComputeFormSubmitterValue({
            elementId: this.currentForm.version.content.id,
            property: "scoreFunctionValue",
            value:
              "{{" +
              this.currentForm.version.content.properties.scoreFunctionBody +
              "}}",
            defaultValue: 0,
            statements: true
          });
          this.score = score;
        } else {
          const components = getFormBuilderComponents(
            this.currentForm.version.content
          );
          const assessmentQuestions = components.filter(
            u => u.elType == "AssessmentQuestion"
          );
          if (assessmentQuestions.length > 0) {
            score = assessmentQuestions.reduce((acc, assessmentQuestion) => {
              const questionValue = this.values[assessmentQuestion.id];

              if (questionValue && questionValue.value !== null) {
                return acc + questionValue.value;
              }

              return acc;
            }, 0);

            this.score = score;
          }
        }
        if (this.isFormGroup && !this.documentGroupId)
          this.documentGroupId = (
            await this.addFormGroupSubmit({ mode: "Results" })
          ).id;

        this.animateLastSaved = false;
        let documentId = this.localDocumentId;
        let documentRefNumber = null;
        let totalSignatures = 0;
        let completedSignatures = 0;
        if (this.localDocumentId) {
          const editedDocument = await this.editFormSubmitterForm({
            submitId: this.localDocumentId,
            mode: "Results",
            status: this.documentStatus,
            parentDocumentId: this.parentDocumentId,
            effectiveDate: formatDateTimeSql(this.effectiveDateTime),
            nextReviewDate: this.nextReviewDate
              ? formatDateOnlyMysql(this.nextReviewDate)
              : null,
            documentGroupId: this.documentGroupId,
            groupSessionId: this.groupSessionId,
            scheduleEventId: this.scheduleEventId,
            scheduleEventParticipantId: this.scheduleEventParticipantId,
            bakedLayout,
            score,
            unlockReason
          });
          totalSignatures = editedDocument.totalSignatures;
          completedSignatures = editedDocument.completedSignatures;
          this.document = await this.getFormSubmitById(this.localDocumentId);
          if (this.document?.score) this.score = this.document.score;
        } else {
          const createdDocument = await this.addFormSubmitterForm({
            mode: "Results",
            documentGroupId: this.documentGroupId,
            groupSessionId: this.groupSessionId,
            scheduleEventId: this.scheduleEventId,
            scheduleEventParticipantId: this.scheduleEventParticipantId,
            status: this.documentStatus,
            parentDocumentId: this.parentDocumentId,
            effectiveDate: formatDateTimeSql(this.effectiveDateTime),
            nextReviewDate: this.nextReviewDate
              ? formatDateOnlyMysql(this.nextReviewDate)
              : null,
            bakedLayout,
            score,
            unlockReason,
            attachForm: this.attachForm
          });
          await this.$refs["documentNotes"].createBatch(
            createdDocument.submitId
          );
          documentId = createdDocument.submitId;
          this.localDocumentId = documentId;
          documentRefNumber = createdDocument.documentRefNumber;
          totalSignatures = createdDocument.totalSignatures;
          completedSignatures = createdDocument.completedSignatures;
          this.document = await this.getFormSubmitById(this.localDocumentId);
          this.initialEffectiveDate = this.effectiveDate;
          this.initialEffectiveTime = this.effectiveTime;
        }

        if (this.preFormComponent) {
          await this.$refs["preFormComponent"].submitComponentData(documentId);
        }
        setTimeout(() => {
          this.animateLastSaved = true;
        }, 500);
        this.showAlertSuccess();
        this.setFormSubmitterFormHasUnsavedChanges({
          hasUnsavedChanges: false
        });
        this.localUnsavedChanges = false;
        this.$emit("onReload", this.sidebarItems);
        this.refetchDocuments = true;
        if (callbackConfirm) {
          callbackConfirm();
          return;
        }

        this.$emit("setCurrentFormItem", {
          sidebarItemIndex: next
            ? this.selectedSidebarItemIndex + 1
            : this.selectedSidebarItemIndex,
          prevDocumentStatus: this.documentStatus,
          prevDocumentId: documentId,
          prevDocumentGroupId: this.documentGroupId,
          documentRefNumber,
          totalSignatures,
          completedSignatures
        });
      } else {
        this.scrolltoErrors();
      }
    },
    async bulkCompleteForm() {
      this.showReviewDocumentsModal = false;
      let documentsForLock = [];

      for (
        let index = 0;
        index < this.documentsForCompleteReview.length;
        index++
      ) {
        const d = this.documentsForCompleteReview[index];

        const documentFromAPI = await this.getFormSubmitById(d.id);

        if (this.document && this.document.id === documentFromAPI.id) {
          documentFromAPI.bakedLayout = `<div>
          <div class="text-left">
            ${
            this.preFormComponent
              ? this.$refs.preFormComponent.getBakedLayout()
              : ""
          }
          </div>
          ${this.$refs.formViewer.getBakedLayout()}
          </div>`;
          const version = await this.getFormBuilderFormVersionById(
            documentFromAPI.versionId
          );
          if (version.content.properties.scoreFunctionBody) {
            documentFromAPI.score = this.superComputeFormSubmitterValue({
              elementId: version.content.id,
              property: "scoreFunctionValue",
              value: "{{" + version.content.properties.scoreFunctionBody + "}}",
              defaultValue: 0,
              statements: true
            });
          } else {
            const components = getFormBuilderComponents(version.content);
            const assessmentQuestions = components.filter(
              u => u.elType == "AssessmentQuestion"
            );
            if (assessmentQuestions.length > 0) {
              documentFromAPI.score = assessmentQuestions.reduce(
                (acc, assessmentQuestion) => {
                  return acc + (this.values[assessmentQuestion.id].value ?? 0);
                },
                0
              );
            }
          }
        }

        documentsForLock.push({
          id: documentFromAPI.id,
          mode: "Results",
          status: "Completed",
          parentDocumentId: documentFromAPI.parentDocumentId || null,
          effectiveDate: documentFromAPI.effectiveDate || null,
          episodeOfCareId: documentFromAPI.episodeOfCareId || null,
          documentGroupId: documentFromAPI.documentGroupId || null,
          groupSessionId: documentFromAPI.groupSessionId || null,
          scheduleEventId: documentFromAPI.scheduleEventId || null,
          scheduleEventParticipantId:
            documentFromAPI.scheduleEventParticipantId || null,
          bakedLayout: documentFromAPI.bakedLayout,
          score:
            documentFromAPI.score != null
              ? documentFromAPI.score.toString()
              : documentFromAPI.score,
          unlockReason: null,
          results: documentFromAPI.results || null,
          totalSignatures: documentFromAPI.totalSignatures,
          completedSignatures: documentFromAPI.completedSignatures,
          nextReviewDate: documentFromAPI.nextReviewDate
        });
      }

      await this.bulkEditFormSubmitterForm(documentsForLock);

      for (
        let index = 0;
        index < this.documentsForCompleteReview.length;
        index++
      ) {
        const d = this.documentsForCompleteReview[index];
        const doc = this.documents.find(dI => dI.documentId == d.id);
        if (doc.category == "doctorOrder" && this.document.id != doc.id) {
          await this.submitDoctorOrderComponentData(d.id);
        }
      }

      if (this.preFormComponent) {
        await this.$refs.preFormComponent.submitComponentData(this.document.id);
      }

      this.showCompleteBulkModal = false;
      if (this.document) {
        this.$emit("setCurrentFormItem", {
          sidebarItemIndex: this.selectedSidebarItemIndex,
          prevDocumentStatus: "Completed",
          prevDocumentId: this.document.id,
          prevDocumentGroupId: this.document.documentGroupId
        });
      }

      this.$emit("onReload");
      this.$emit("onModify", {
        refetchDocuments: true,
        noCloseEditDocumentEditor: true
      });
      this.showAlertSuccess();
    },
    async submitDoctorOrderComponentData(documentId) {
      const doctorOrder = await doctorOrderServer.getFromDocument(documentId);
      if (doctorOrder) {
        let formId = doctorOrder.id;
        let form = {
          scheduledMedications: doctorOrder.scheduledMedications.map(
            medication => {
              const times = {};
              for (let index = 0; index < medication.times.length; index++) {
                const time = medication.times[index];
                times[index] = time;
              }
              return {
                medication: medication.medication
                  ? {
                    value: medication.medication.id,
                    label: medication.medication.name
                  }
                  : null,
                route: medication.medicationRoute
                  ? {
                    value: medication.medicationRoute.id,
                    label: medication.medicationRoute.name
                  }
                  : null,
                dosage: medication.dosageAmount,
                measurementUnit: medication.unitOfMeasurement
                  ? {
                    value: medication.unitOfMeasurement.id,
                    label: medication.unitOfMeasurement.name
                  }
                  : null,
                startDate: medication.startDate
                  ? this.formatDateTimeMysql(medication.startDate)
                  : null,
                endDate: medication.endDate
                  ? this.formatDateTimeMysql(medication.endDate)
                  : null,
                untilDischarge: medication.untilDischarge,
                frequencyId:
                  medication.frequency.charAt(0).toLowerCase() +
                  medication.frequency.slice(1),
                daysIntervalId: this.getDaysIntervalId(
                  medication.interval,
                  medication.intervalAmount
                ),
                weekDays: [
                  ...(medication.sunday ? ["0"] : []),
                  ...(medication.monday ? ["1"] : []),
                  ...(medication.tuesday ? ["2"] : []),
                  ...(medication.wednesday ? ["3"] : []),
                  ...(medication.thursday ? ["4"] : []),
                  ...(medication.friday ? ["5"] : []),
                  ...(medication.saturday ? ["6"] : [])
                ],
                timesPerDayId: `${medication.timesPerDay}Time${
                  medication.timesPerDay > 1 ? "s" : ""
                }PerDay`,
                times: times,
                instructions: medication.instructions,
                predefinedProtocol: medication.predefinedProtocol
                  ? {
                    value: medication.predefinedProtocol.id,
                    label: medication.predefinedProtocol.name
                  }
                  : null
              };
            }
          ),
          prnMedications: doctorOrder.prnMedications.map(prnMedication => {
            return {
              medication: prnMedication.medication
                ? {
                  value: prnMedication.medication.id,
                  label: prnMedication.medication.name
                }
                : null,
              route: prnMedication.medicationRoute
                ? {
                  value: prnMedication.medicationRoute.id,
                  label: prnMedication.medicationRoute.name
                }
                : null,
              dosage: prnMedication.dosageAmount,
              measurementUnit: prnMedication.unitOfMeasurement
                ? {
                  value: prnMedication.unitOfMeasurement.id,
                  label: prnMedication.unitOfMeasurement.name
                }
                : null,
              startDate: prnMedication.startDate
                ? this.formatDateTimeMysql(prnMedication.startDate)
                : null,
              endDate: prnMedication.stopDate
                ? this.formatDateTimeMysql(prnMedication.stopDate)
                : null,
              instructions: prnMedication.instructions,
              maximumDosagePerDay: prnMedication.maximumDosagePerDay,
              predefinedProtocol: prnMedication.predefinedProtocol
                ? {
                  value: prnMedication.predefinedProtocol.id,
                  label: prnMedication.predefinedProtocol.name
                }
                : null
            };
          }),
          predefinedProtocols: doctorOrder.predefinedProtocols.map(pP => ({
            value: pP.id,
            label: pP.name,
            data: pP
          })),
          discontinuedMedications: doctorOrder.discontinuedMedications.map(
            m => ({
              ...(m.scheduledMedication
                ? { id: m.scheduledMedication.id, type: "scheduled" }
                : { id: m.prnMedication.id, type: "prn" })
            })
          )
        };
        const formData = {
          documentId: documentId,
          scheduledMedications: form.scheduledMedications.map(
            scheduledMedication => {
              return {
                medicationId: scheduledMedication.medication.value,
                dosageAmount: parseFloat(scheduledMedication.dosage),
                unitOfMeasurementId: scheduledMedication.measurementUnit.value,
                medicationRouteId: scheduledMedication.route.value,
                instructions: scheduledMedication.instructions,
                startDate: scheduledMedication.startDate
                  ? this.formatDateTimeSql(scheduledMedication.startDate)
                  : null,
                endDate: scheduledMedication.endDate
                  ? this.formatDateTimeSql(scheduledMedication.endDate)
                  : null,
                untilDischarge: scheduledMedication.untilDischarge,
                frequency:
                  scheduledMedication.frequencyId.charAt(0).toUpperCase() +
                  scheduledMedication.frequencyId.slice(1),
                interval: this.toIntervalAmounts(scheduledMedication).frequency,
                intervalAmount: this.toIntervalAmounts(scheduledMedication)
                  .amount,
                timesPerDay: Object.values(scheduledMedication.times).length,
                monday: scheduledMedication.weekDays.indexOf("1") >= 0,
                tuesday: scheduledMedication.weekDays.indexOf("2") >= 0,
                wednesday: scheduledMedication.weekDays.indexOf("3") >= 0,
                thursday: scheduledMedication.weekDays.indexOf("4") >= 0,
                friday: scheduledMedication.weekDays.indexOf("5") >= 0,
                saturday: scheduledMedication.weekDays.indexOf("6") >= 0,
                sunday: scheduledMedication.weekDays.indexOf("0") >= 0,
                times: Object.values(scheduledMedication.times),
                predefinedProtocolId:
                scheduledMedication.predefinedProtocol?.value
              };
            }
          ),
          prnMedications: form.prnMedications.map(prnMedication => {
            return {
              medicationId: prnMedication.medication.value,
              dosageAmount: parseFloat(prnMedication.dosage),
              unitOfMeasurementId: prnMedication.measurementUnit.value,
              medicationRouteId: prnMedication.route.value,
              instructions: prnMedication.instructions,
              maximumDosagePerDay: prnMedication.maximumDosagePerDay,
              startDate: prnMedication.startDate
                ? this.formatDateTimeSql(prnMedication.startDate)
                : null,
              stopDate: prnMedication.endDate
                ? this.formatDateTimeSql(prnMedication.endDate)
                : null,
              predefinedProtocolId: prnMedication.predefinedProtocol?.value
            };
          }),
          predefinedProtocolIds: form.predefinedProtocols.map(pP => pP.value),
          discontinuedMedications: form.discontinuedMedications.map(m => ({
            ...(m.type == "scheduled"
              ? { scheduledMedicationId: m.id }
              : { prnMedicationId: m.id })
          }))
        };
        await doctorOrderServer.update(formId, formData);
      }
    },
    getDaysIntervalId(intervalLabel, intervalAmount) {
      switch (`${intervalAmount}${intervalLabel}`) {
        case "2Days":
          return "every2Days";
        case "3Days":
          return "every3Days";
        case "1Weeks":
          return "1timePerWeek";
        case "2Weeks":
          return "everyTwoWeeks";
        case "3Weeks":
          return "every3Weeks";
        case "28Days":
          return "every28Days";
        case "30Days":
          return "every30Days";

        default:
          return null;
      }
    },
    toIntervalAmounts(scheduledMedication) {
      switch (scheduledMedication.daysIntervalId) {
        case "every2Days":
          return {
            frequency: "Days",
            amount: 2
          };
        case "every3Days":
          return {
            frequency: "Days",
            amount: 3
          };
        case "1timePerWeek":
          return {
            frequency: "Weeks",
            amount: 1
          };
        case "everyTwoWeeks":
          return {
            frequency: "Weeks",
            amount: 2
          };
        case "every3Weeks":
          return {
            frequency: "Weeks",
            amount: 3
          };
        case "every28Days":
          return {
            frequency: "Days",
            amount: 28
          };
        case "every30Days":
          return {
            frequency: "Days",
            amount: 30
          };

        default:
          return {
            frequency: "Days",
            amount: 1
          };
      }
    },
    prevSetCurrentFormItem(sidebarItemIndex) {
      if (this.localUnsavedChanges && this.sidebarItems?.length < 2) {
        this.$dialog
          .confirm(
            {
              title: "Do you want to save your changes?"
            },
            {
              view: "confirm-unsaved-changes"
            }
          )
          .then(async ({ data }) => {
            if (data.confirmValue) {
              this.submitForm();
            } else {
              this.$emit("setCurrentFormItem", {
                sidebarItemIndex: sidebarItemIndex,
                prevDocumentStatus: this.document ? this.document.status : "",
                prevDocumentId: this.localDocumentId,
                prevDocumentGroupId: this.documentGroupId,
                totalSignatures: this.document
                  ? this.document.totalSignatures
                  : "",
                completedSignatures: this.document
                  ? this.document.completedSignatures
                  : ""
              });
            }
          })
          .catch(function() {});
      } else {
        this.$emit("setCurrentFormItem", {
          sidebarItemIndex: sidebarItemIndex,
          prevDocumentStatus: this.document ? this.document.status : "",
          prevDocumentId: this.localDocumentId,
          prevDocumentGroupId: this.documentGroupId,
          totalSignatures: this.document ? this.document.totalSignatures : "",
          completedSignatures: this.document
            ? this.document.completedSignatures
            : ""
        });
      }
    },
    getFormDocumentColor(sidebarItem) {
      if (sidebarItem.documentStatus == "Completed") return "success";
      if (sidebarItem.documentStatus == "Pending") return "warning";
      if (sidebarItem.documentStatus == "Draft") return "draft";
      return "";
    },
    setStatus(newStatus) {
      this.documentStatus = newStatus;
      this.setFormSubmitterFormHasUnsavedChanges({ hasUnsavedChanges: true });
      this.localUnsavedChanges = true;
    },
    getStatusClass(document) {
      if (document.documentStatus == "Completed") return "success";
      if (document.documentStatus == "Pending") return "warning";
      if (!document.documentStatus) return "danger";
      return "danger";
    },
    getParticipantStatusClass(status) {
      if (status == "Show") return "success";
      if (status == "Canceled") return "warning";
      return "danger";
    },
    getStatus(document) {
      return document && document.documentStatus
        ? document.documentStatus
        : "NOT CREATED";
    },
    async closeModal() {
      const scheduleEvent = this.scheduleEventId
        ? await scheduleEventServer.get(this.scheduleEventId)
        : null;
      if (scheduleEvent && !scheduleEvent.services.length) {
        this.$dialog.alert(
          {
            title: "Please add a service before you leave!"
          },
          {
            view: "error"
          }
        );
      } else {
        if (this.hasUnsavedChanges) {
          this.$dialog
            .confirm(
              {
                title: "Do you want to save your changes?"
              },
              {
                view: "confirm-unsaved-changes"
              }
            )
            .then(async ({ data }) => {
              if (data.confirmValue) {
                this.submitForm({
                  callbackConfirm: () => {
                    this.$emit("onModify", {
                      refetchDocuments: this.refetchDocuments
                    });
                  }
                });
              } else {
                this.$emit("onModify", {
                  refetchDocuments: this.refetchDocuments
                });
              }
            })
            .catch(function() {});
        } else {
          this.$emit("onModify", { refetchDocuments: this.refetchDocuments });
        }
      }
    },
    async openOmtTab() {
      if (!(this.eocId in this.omtResults)) {
        const results = await documentServer.getOmtResults(this.eocId);
        results.sort((a, b) => a.effectiveDate.localeCompare(b.effectiveDate));
        this.$set(this.omtResults, this.eocId, results);
      }

      this.selectedSidebarTab = "omt";
    },
    onAllergyDelete(allergyId) {
      const controlId = Object.keys(this.values).find(x =>
        x.toLowerCase().startsWith("clientallergies")
      );
      if (!controlId) return;
      const control =
        this.values[controlId] == ""
          ? (this.values[controlId] = [])
          : this.values[controlId];
      let index = null;
      if (control != []) {
        index = control.findIndex(x => x.allergyId == allergyId);
        if (index < 0) return;
        control.splice(index, 1);
        this.setFormSubmitterFormHasUnsavedChanges({ hasUnsavedChanges: true });
        this.localUnsavedChanges = true;
      }
    },
    onAllergyModify(allergyData) {
      const controlId = Object.keys(this.values).find(x =>
        x.toLowerCase().startsWith("clientallergies")
      );
      if (!controlId) return;
      const control =
        this.values[controlId] == ""
          ? (this.values[controlId] = [])
          : this.values[controlId];
      let formData = {
        allergen: allergyData.allergenName,
        allergyType: allergyData.allergyTypeName,
        reaction: allergyData.reactionName,
        severity: allergyData.severityName,
        allergyId: allergyData.id ? allergyData.id : ""
      };
      if (!allergyData.id) {
        control.push(formData);
      } else {
        let index = null;
        if (control != []) {
          index = control.findIndex(x => x.allergyId == allergyData.id);
          if (index < 0) return;
          control.splice(index, 1, formData);
        }
      }
      this.setFormSubmitterFormHasUnsavedChanges({ hasUnsavedChanges: true });
      this.localUnsavedChanges = true;
    },
    onIcdCodesTabChange(icdCodeChange) {
      const controlId = Object.keys(this.values).find(x =>
        x.toLowerCase().startsWith("clientdiagnosiscodes")
      );
      if (!controlId) return;
      const control =
        this.values[controlId] == ""
          ? (this.values[controlId] = [])
          : this.values[controlId];

      if (!icdCodeChange.isDelete) {
        let index = null;
        if (control != []) {
          index = control.findIndex(x => x.id == icdCodeChange.id);
        }
        let formData = {
          id: icdCodeChange.id,
          code: icdCodeChange.icdCodeDescription,
          description: icdCodeChange.description,
          status: icdCodeChange.status,
          resolvedBy: icdCodeChange.resolvedBy,
          activeFrom: icdCodeChange.activeFrom,
          category: icdCodeChange.category
        };
        if (icdCodeChange.isCreate) {
          if (index != null) {
            if (index >= 0) return;
          }
          control.push(formData);
        } else {
          control.splice(index, 1, formData);
        }
      }
      if (icdCodeChange.isDelete) {
        const index = control.findIndex(x => x.id == icdCodeChange.id);
        if (index < 0) return;

        control.splice(index, 1);
      }

      let prymaryCategory = control
        .filter(x => x.category == "Primary")
        .sort((a, b) => a.code.localeCompare(b.code));
      let secundaryCategory = control
        .filter(x => x.category == "Secondary")
        .sort((a, b) => a.code.localeCompare(b.code));
      let tertiaryCategory = control
        .filter(x => x.category == "Tertiary")
        .sort((a, b) => a.code.localeCompare(b.code));
      this.values[controlId] = [
        ...prymaryCategory,
        ...secundaryCategory,
        ...tertiaryCategory
      ];
      this.setFormSubmitterFormHasUnsavedChanges({ hasUnsavedChanges: true });
      this.localUnsavedChanges = true;
    },
    getClientDiagnosisCodeKeys(obj) {
      const clientDiagnosisCodeKeys = Object.getOwnPropertyNames(
        obj
      ).filter(key => key.includes("ClientDiagnosisCodes"));
      return clientDiagnosisCodeKeys;
    },
    preventLossDocumentICD() {
      const document = JSON.parse(JSON.stringify(this.lastDocument));

      // cdc: Client Diagnosis Code
      const cdcKeys = this.getClientDiagnosisCodeKeys(this.values || {});
      const cdcKeysFromLastDocument = this.getClientDiagnosisCodeKeys(
        this.lastDocument?.results || {}
      );

      if (cdcKeysFromLastDocument.length > 0 && cdcKeys.length > 0) {
        cdcKeys.map(cdc => {
          if (cdcKeysFromLastDocument.some(x => x === cdc))
            document.results[cdc] = [...this.values[cdc]];
        });
      }

      return document;
    },
    async loadLastResult() {
      let formCopy = { ...this.currentForm };
      this.currentForm = null;
      if (this.lastDocument.scheduleEventId) {
        const scheduleEvent = await scheduleEventServer.get(
          this.lastDocument.scheduleEventId
        );
        if (scheduleEvent.type.name == "Group Session") {
          this.disableDocumentEffectiveDatePicker = true;
        }
      }

      let lastDocument = this.preventLossDocumentICD();

      lastDocument = this.preserveExcludedComponentValue(
        lastDocument,
        formCopy.version.content.layout
      );

      await this.initializeFormSubmitterForm({
        formId: this.formId,
        formName: formCopy.form.name,
        version: formCopy.version,
        client: this.client,
        eoc: this.eoc,
        document: lastDocument,
        otherResults: this.otherResults,
        defaultValues: this.defaultValues,
        showType: "form-submitter",
        selectedLocation: this.selectedLocation
      });

      this.currentForm = formCopy;

      this.setFormSubmitterFormHasUnsavedChanges({ hasUnsavedChanges: true });
      this.localUnsavedChanges = true;
    },
    preserveExcludedComponentValue(document, layout) {
      const componentsValue = document.results;
      layout.rows.map(row => {
        row.columns.map(column => {
          column.components.map(component => {
            const hasExcludeActivated =
              component.properties.excludeFromLoadFromLastResult;

            if (hasExcludeActivated) {
              componentsValue[
                component.id
                ] = this.getFormSubmitterComponentValue(component.id);
            }
          });
        });
      });
      document.results = componentsValue;
      return document;
    },
    triggerBulkModal() {
      this.showCompleteBulkModal = true;
    },
    updateNextReviewDate(date) {
      this.nextReviewDate = date;
    },
    async signAll(documentsInfo, selectedLabels, signature) {
      this.showSignModal = false;
      let docList = [];
      let updateDocument = false;
      documentsInfo.forEach(doc => {
        updateDocument = false;
        doc.version.content.layout.rows.forEach(row => {
          row.columns.forEach(col => {
            col.components.forEach(component => {
              if (
                component.elType == "Signature" &&
                selectedLabels.includes(component.properties.label) &&
                !doc.results[component.id]
              ) {
                var signatureValue = {
                  signature: signature.signature,
                  date: signature.date
                };
                if (component.properties.type == "client") {
                  let patient = this.sidebarItems.find(
                    sidebarItem => sidebarItem.documentId == doc.id
                  ).patientData;
                  signatureValue.client = {
                    firstName: patient.firstName,
                    middleName: patient.middleName,
                    lastName: patient.lastName,
                    mrn: patient.mrn
                  };
                } else {
                  signatureValue.user = signature.user;
                }
                doc.results[component.id] = signatureValue;
                doc.completedSignatures++;
                updateDocument = true;
              }
            });
          });
        });
        if (updateDocument) {
          docList.push({
            formLayout: doc.version.content.layout,
            document: doc,
            isDoctorOrderLoaded: doc.form.category != "doctorOrder",
            isReleaseOfInformationLoaded:
              doc.form.category != "releaseOfInformation",
            isMainLayoutLoaded: false,
            mainLayout: "",
            doctorOrderLayout: "",
            releaseOfInformationLayout: ""
          });
        }
      });
      this.updatedDocuments.splice(0, this.updatedDocuments.length, ...docList);
      if (this.updatedDocuments.length > 0) {
        let sidebarItemIndex = this.sidebarItems.findIndex(
          item => item.documentId == this.updatedDocuments[0].document.id
        );
        await this.initializeFormData(sidebarItemIndex, false);
        this.updatedDocumentsRenderIndex = 0;
      } else {
        this.updatedDocumentsRenderIndex = -1;
      }
    },
    saveDocument() {
      var some = this.updatedDocuments.some(
        d =>
          !d.isDoctorOrderLoaded ||
          !d.isMainLayoutLoaded ||
          !d.isReleaseOfInformationLoaded
      );

      if (!some) {
        this.updatedDocuments.forEach(d => {
          d.document.bakedLayout = `<div>
          <div class="text-left">
            ${d.doctorOrderLayout}
          </div>
          <div class="text-left">
            ${d.releaseOfInformationLayout}
          </div>
          ${d.mainLayout}
        </div>`;
        });
        this.showReviewDocumentsModal = true;
      }
    },
    setMainLayoutMounted(doc, bakedLayout) {
      doc.isMainLayoutLoaded = true;
      doc.mainLayout = bakedLayout;
      this.goNextDocumentSign(doc);
      this.saveDocument();
    },
    setDoctorOrderlayoutMounted(doc, bakedLayout) {
      doc.isDoctorOrderLoaded = true;
      doc.doctorOrderLayout = bakedLayout;
      this.goNextDocumentSign(doc);
      this.saveDocument();
    },
    setReleaseOfInformationlayoutMounted(doc, bakedLayout) {
      doc.isReleaseOfInformationLoaded = true;
      doc.releaseOfInformationLayout = bakedLayout;
      this.goNextDocumentSign(doc);
      this.saveDocument();
    },
    goNextDocumentSign(doc) {
      if (
        doc.isDoctorOrderLoaded &&
        doc.isMainLayoutLoaded &&
        this.updatedDocumentsRenderIndex < this.updatedDocuments.length - 1
      ) {
        let nextIndex = this.updatedDocumentsRenderIndex + 1;
        this.updatedDocumentsRenderIndex = -1;
        setTimeout(async () => {
          let sidebarItemIndex = this.sidebarItems.findIndex(
            item =>
              item.documentId == this.updatedDocuments[nextIndex].document.id
          );
          await this.initializeFormData(sidebarItemIndex, false);
          this.updatedDocumentsRenderIndex = nextIndex;
        }, 0);
      }
    },
    async confirmSigning() {
      this.showReviewDocumentsModal = false;
      await this.bulkEditFormSubmitterForm(
        this.updatedDocuments.map(d => d.document)
      );
      this.updatedDocuments.splice(0);
      this.updatedDocumentsRenderIndex = -1;
      this.initializeFormData();
      this.updateSignaturesCount();
    },
    closeSigning() {
      this.updatedDocuments.splice(0);
      this.updatedDocumentsRenderIndex = -1;
      this.initializeFormData();
      this.reviewDocumentMode = "";
    },
    getDoctorOrderOrNull(form) {
      if (form && form.category == "doctorOrder") {
        return DocumentDoctorOrder;
      }
      return null;
    },
    getReleaseOfInformationOrNull(form) {
      if (form && form.category == "releaseOfInformation") {
        return DocumentReleaseOfInformation;
      }
      return null;
    },
    async completeBulkDocumentsReview(docs) {
      this.showCompleteBulkModal = false;
      this.reviewDocumentMode = "complete";
      const ids = docs.map(item => item.documentId);
      const content = await documentServer.getDocumentsContent(ids);
      this.documentsForCompleteReview = content.map(x => {
        return {
          id: x.id,
          bakedLayout: x.bakedLayout
        };
      });
      this.showReviewDocumentsModal = true;
    },
    async updateSignaturesCount() {
      const documents = await documentServer.documentsFromIdsImproved(
        this.pendingOrDraftOrCompletedDocuments
      );
      this.documentsFromSidebarItemsIds = documents;
      documents.forEach(document => {
        this.sidebarItems.forEach(sidebarItem => {
          if (document.documentId == sidebarItem.documentId) {
            sidebarItem.documentRefNumber = document.documentRefNumber;
            sidebarItem.patient = `${document.patient.firstName} ${
              document.patient.middleName ? document.patient.middleName : ""
            } ${document.patient.lastName}`;
            sidebarItem.totalSignature = document.totalSignatures;
            sidebarItem.completedSignature = document.completedSignatures;
            sidebarItem.mrn = document.episodeOfCare.mrnEocn;
            sidebarItem.date = document.effectiveDate;
          }
        });
      });
    },
    formIsEnabledInLocation(item) {
      if (item && this.editorShown) {
        return (
          this.formsMainAndMasterTreatmentPlanCurrentLocation.filter(
            element => element.id === item.formId
          ).length > 0 || item.isEnabledInScheduleEventLocation
        );
      }
    },
    async pasteContentFromClipboard() {
      let formCopy = { ...this.currentForm };
      this.currentForm = null;

      this.pasteFormValuesFromClipboard();
      await this.initializeFormSubmitterForm({
        formId: this.formId,
        formName: formCopy.form.name,
        version: formCopy.version,
        client: this.client,
        eoc: this.eoc,
        document: {
          results: this.values
        },
        otherResults: this.otherResults,
        defaultValues: this.defaultValues,
        showType: "form-submitter",
        selectedLocation: this.selectedLocation
      });

      this.currentForm = formCopy;

      this.setFormSubmitterFormHasUnsavedChanges({ hasUnsavedChanges: true });
      this.localUnsavedChanges = true;
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      hasUnsavedChanges: state => state.form.hasUnsavedChanges,
      values: state => state.form.values,
      computedProperties: state => state.form.computedProperties
    }),
    ...mapGetters("formSubmitter", [
      "getFormSubmitById",
      "superComputeFormSubmitterValue",
      "getFormSubmitterComponentValue"
    ]),
    ...mapGetters("formGroupSubmitter", ["getFormGroupSubmitById"]),
    ...mapGetters("formGroup", ["getFormGroupById"]),
    ...mapGetters("formBuilder", [
      "getFormBuilderFormById",
      "getFormBuilderFormVersionById"
    ]),
    ...mapGetters("layout", [
      "hasCurrentUserDocumentPermission",
      "getCurrentAdjustedDateTime",
      "hasCurrentUserPermissionAccess"
    ]),
    ...mapGetters("client", ["formsMainAndMasterTreatmentPlanCurrentLocation"]),
    ...mapState("layout", {
      selectedLocation: state => state.selectedLocation,
      systemSetting: state => state.systemSetting,
      currentUser: state => state.currentUser
    }),
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    scheduleEventIdValue() {
      if (this.scheduleEventId) return this.scheduleEventId;
      if (this.document && this.document.scheduleEventId)
        return this.document.scheduleEventId;
      return null;
    },
    statuses() {
      return [
        {
          value: "Draft",
          label: "Draft",
          class: "bg-danger",
          disabled: this.document && this.document.status == "Completed"
        },
        {
          value: "Pending",
          label: "Pending",
          class: "bg-warning",
          disabled: this.document && this.document.status == "Completed"
        },
        {
          value: "Completed",
          label: "Completed",
          class: "bg-success",
          disabled: !this.hasCurrentUserDocumentPermission(
            this.formId,
            "hasCompleteAccess"
          )
        }
      ];
    },
    preFormComponent() {
      if (
        this.currentForm &&
        this.currentForm.form &&
        this.currentForm.form.category == "doctorOrder"
      ) {
        return DocumentDoctorOrder;
      } else if (
        this.currentForm &&
        this.currentForm.form &&
        this.currentForm.form.category == "releaseOfInformation"
      ) {
        return DocumentReleaseOfInformation;
      }
      return null;
    },
    copyPasteActive() {
      if (
        (this.currentForm &&
          this.currentForm.form &&
          this.currentForm.form.category == "doctorOrder") ||
        this.currentForm.form.category == "releaseOfInformation"
      ) {
        return false;
      }
      return true;
    },
    effectiveDateTimePickerDisabled() {
      return (
        this.disableEffectiveDatePicker ||
        this.disableDocumentEffectiveDatePicker
      );
    },
    thereIsNoPendingDocuments() {
      return this.sidebarItems.find(item => item.documentStatus === "Pending")
        ? false
        : true;
    },
    formIsTreatmentPlan() {
      return this.currentForm &&
      this.currentForm.form &&
      this.currentForm.form.category == "masterTreatmentPlan"
        ? true
        : false;
    },
    pendingOrDraftDocuments() {
      return this.sidebarItems
        .filter(
          d => d.documentStatus == "Pending" || d.documentStatus == "Draft"
        )
        .map(x => x.documentId);
    },
    pendingOrDraftOrCompletedDocuments() {
      return this.sidebarItems
        .filter(
          d =>
            d.documentStatus == "Pending" ||
            d.documentStatus == "Draft" ||
            d.documentStatus == "Completed"
        )
        .map(x => x.documentId);
    }
  },
  watch: {
    pendingOrDraftOrCompletedDocuments: {
      async handler() {
        this.updateSignaturesCount();
      },
      immediate: true
    },
    effectiveDateTime() {
      this.setFormSubmitterFormHasUnsavedChanges({ hasUnsavedChanges: true });
      this.setDocumentData({
        status: this.documentStatus,
        effectiveDate: this.effectiveDateTime
      });
    },
    nextReviewDate(date) {
      date === "" ? (this.nextReviewDate = null) : null;
    },
    reloadSelectedDocument() {
      this.initializeFormData();
    },
    selectedSidebarItemIndex(newValue) {
      const documentId = this.sidebarItems[newValue].documentId;
      this.$refs["documentNotes"].getNotes(documentId);
    },
    documentStatus() {
      this.setDocumentData({
        status: this.documentStatus,
        effectiveDate: this.effectiveDateTime
      });
    }
  }
};
</script>

<style scoped>
.builder {
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100% - 95px);
  position: relative;
}

.disable-form {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 99;
  opacity: 0.3;
}

.effective-date-container {
  height: 70px;
  max-height: 70px;
}

.form-title-container {
  max-width: calc(100% - 595px);
}

.text-shadow {
  text-shadow: 2px 2px 4px #000000;
}

.modal-subtitle {
  font-size: 14px;
  margin-top: -4px;
}

.overlay {
  position: absolute;
  top: 10px;
  left: 10px;
  width: calc(100% - 20px);
  height: calc(100% - 20px);
  background: rgba(255, 255, 255, 0.5);
  z-index: -1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.overlay.show {
  z-index: 100;
}

.sidebar {
  width: 350px;
  background-color: #f5f8fc;
  display: flex;
  flex-direction: column;
  z-index: 1;
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
  margin-top: 10px;
  margin-bottom: 10px;
}

.sidebar-inner {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  width: 350px;
  padding-bottom: 15px;
}

.sidebar-tab-title {
  border-bottom-width: 3px !important;
  font-size: 14px;
  font-weight: 800;
  text-align: center;
  flex-grow: 1;
}

.document-instructions {
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}

.animate-container {
  border-radius: 3px;
  animation: highlight 2000ms ease-out;
}

@keyframes highlight {
  0% {
    background-color: #90caf9;
  }
  100% {
    background-color: #f5f8fc;
  }
}

.last-saved-container {
  position: absolute;
  height: 58px;
  padding-top: 18px;
  left: 0px;
  padding-left: 20px;
  padding-right: 20px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.border-radius-top {
  border-top-right-radius: 0.3rem;
  border-top-left-radius: 0.3rem;
}

.border-radius-bottom {
  border-bottom-right-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
}

.main-container {
  -webkit-box-shadow: -10px 0px 13px -7px #000000a6,
  10px 0px 13px -7px #000000a6, 5px 5px 15px 5px rgba(0, 0, 0, 0);
  box-shadow: -10px 0px 13px -7px #000000a6, 10px 0px 13px -7px #000000a6,
  5px 5px 15px 5px rgba(0, 0, 0, 0);
}

.sidebar-badge {
  min-width: 100px;
  height: 32px;
  font-weight: 600;
  background-color: #e5e8eb;
}

.sidebar-badge:hover {
  min-width: 100px;
  background: #2196f3;
  height: 32px;
  font-weight: 600;
  animation: 2s ease-out;
  color: white;
}

.sidebar-badge.selected-badge {
  min-width: 100px;
  background: #2196f3;
  height: 32px;
  font-weight: 600;
  animation: 2s ease-out;
  color: white;
}
</style>

<style>
.effective-date-container .input-group-prepend,
.input-group-append {
  display: initial;
}

.single-document-modal .modal-content {
  border: none;
  border-radius: 0 30px 30px 0;
}

.single-document-modal.multiple-documents .modal-content {
  border-radius: 30px;
}

.single-document-modal .modal-body {
  padding: 0px !important;
}

.document-modal .modal-dialog {
  border-radius: 0;
}

.document-modal .shadow-form {
  z-index: 2;
  box-shadow: 0px 0px 14px -2px rgba(0, 0, 0, 0.5);
  border: none !important;
}

.document-modal .document-container {
  height: calc(100% - 186px);
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
}

div >>> .dropdown-menu {
  width: 100%;
}

.document-modal .modal-content {
  background-color: transparent;
}

#option-text {
  display: inline;
  margin-right: 0.5rem;
}

.headers-options {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}

.fa-times {
  color: red;
  width: 16px;
}
</style>
